/** Loose email validity check shared across the quiz and checkout flows. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SUPPORT_EMAIL = 'support@moneyfox.io';

export function isValidEmail(value: string | undefined | null): boolean {
  return typeof value === 'string' && EMAIL_RE.test(value.trim());
}
